/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum CustomConditionType {
    Base = '0',
    Numeric = 3,
    Dropdown = 5,
    Checkbox = 6,
    Date = 7,
    TimeOfDay = 8,
}
